import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function WhyWeCreated() {
  return <section className="py-24 bg-white" data-id="element-380">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-381">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-382">
          {/* Left: Image */}
          <motion.div className="relative h-[600px] rounded-2xl overflow-hidden shadow-lg order-2 lg:order-1" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-383">
            <img src="https://cdn.magicpatterns.com/uploads/iS3hRcSZNvyoP3fsBk9TEJ/Tarjeta-SOS-de-Seguridad.png" alt="Mamá alimentando a su bebé en la mesa" className="w-full h-full object-cover object-center" data-id="element-384" />
            <div className="absolute inset-0 bg-olive/10 mix-blend-multiply" data-id="element-385" />
          </motion.div>

          {/* Right: Text */}
          <div className="space-y-8 order-1 lg:order-2" data-id="element-386">
            <motion.h2 className="text-4xl lg:text-5xl font-serif text-charcoal leading-tight" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-387">
              Creamos Primeros Bocados porque sabemos lo abrumador que puede
              sentirse este comienzo
            </motion.h2>

            <motion.div className="space-y-6 text-lg text-warmGray leading-relaxed" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-388">
              <p data-id="element-389">
                Entre consejos contradictorios, miedo al atragantamiento, dudas
                sobre alérgenos y presión por hacerlo todo bien, muchas familias
                empiezan esta etapa con más ansiedad que ilusión.
              </p>
              <p data-id="element-390">
                Primeros Bocados nace para convertirse en una brújula: una guía
                cálida, útil y bien estructurada que reúne seguridad, nutrición,
                metodología, recetas y recursos prácticos en un solo lugar.
              </p>
              <p data-id="element-391">
                Queremos que sientas que sí puedes hacerlo, sin caer en extremos
                y sin perder la calma.
              </p>
            </motion.div>

            <motion.div className="pt-6 border-t border-sand flex items-center gap-6" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} data-id="element-392">
              <div className="flex items-center gap-3" data-id="element-393">
                <span className="bg-terracotta/15 text-terracotta text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-394">
                  -66%
                </span>
                <span className="text-lg text-warmGray/60 line-through font-serif" data-id="element-395">
                  $29.00
                </span>
                <span className="text-3xl font-serif text-charcoal" data-id="element-396">$9.99</span>
              </div>
              <a href="https://epikkastore.com/cart/45054208213015:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="bg-olive hover:bg-olive/90 text-white px-8 py-4 rounded-lg font-medium transition-colors shadow-sm inline-block text-center" data-id="element-397">
                Comprar ahora
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}